import React, { useState } from "react";

import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { Grid, Typography, Button } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {},
}));

const Header = (props) => {
  const { className, update, buttonText, onActionBtn, ...rest } = props;
  const classes = useStyles();

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Grid alignItems="flex-end" container justify="space-between" spacing={3}>
        <Grid item>
          <Typography component="h2" gutterBottom variant="overline">
            {props.title}
          </Typography>
          <Typography component="h1" variant="h3">
            {props.subtitle}
          </Typography>
        </Grid>
        <Grid item>
          <Button
            className="mr-1"
            color="primary"
            onClick={() => onActionBtn()}
            variant="contained"
          >
            {buttonText}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string,
};

export default Header;
